const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

export function getPageLocalHost(): string | null {
  const hostname = globalThis.location?.hostname;

  return hostname && LOCAL_HOSTS.has(hostname) ? hostname : null;
}

export function toJwtAllowedDomain(value?: string | null): string | null {
  if (!value) {
    return null;
  }

  try {
    const url = value.includes("://") ? new URL(value) : new URL(`http://${value}`);
    return url.port ? `${url.hostname}:${url.port}` : url.hostname;
  } catch {
    const host = value.replace(/^https?:\/\//, "").split("/")[0];

    return host || null;
  }
}

export function getJwtAllowedDomains(extra: Array<string | undefined | null> = []): string[] {
  const domains = new Set<string>([
    "localhost:8000",
    "127.0.0.1:8000",
    "localhost:8001",
    "127.0.0.1:8001",
  ]);

  for (const value of extra) {
    const domain = toJwtAllowedDomain(value);
    if (domain) {
      domains.add(domain);
    }
  }

  return [...domains];
}

export function alignUrlToPageHost(url: string): string {
  const pageHost = getPageLocalHost();
  if (!pageHost || !/^https?:\/\//.test(url)) {
    return url;
  }

  return url.replace(
    /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)/,
    `http://${pageHost}$2`,
  );
}
